import { css } from '@emotion/css';
import { css as globalCss } from '@emotion/react';
import colors from '@/theme/colors';

export const pacContainerGlobalStyles = globalCss`
  #center-of-map-suggestions.pac-container .pac-item {
    color: ${colors.prussian};
    background-color: ${colors.white};
  }

  #center-of-map-suggestions.pac-container .pac-item .pac-matched {
    color: ${colors.prussian};
  }

  #center-of-map-suggestions.pac-container .pac-item:hover,
  #center-of-map-suggestions.pac-container .pac-item-selected,
  #center-of-map-suggestions.pac-container .pac-item-selected:hover {
    background-color: ${colors.prussianMid} !important;
    color: ${colors.white} !important;
  }

  #center-of-map-suggestions.pac-container .pac-item:hover .pac-matched,
  #center-of-map-suggestions.pac-container .pac-item-selected .pac-matched,
  #center-of-map-suggestions.pac-container .pac-item-selected:hover .pac-matched {
    color: ${colors.white} !important;
  }

  #center-of-map-suggestions.pac-container .pac-item:hover span,
  #center-of-map-suggestions.pac-container .pac-item-selected span,
  #center-of-map-suggestions.pac-container .pac-item-selected:hover span {
    color: inherit;
  }

  #center-of-map-suggestions.pac-container .pac-item:hover .pac-icon,
  #center-of-map-suggestions.pac-container .pac-item-selected .pac-icon {
    filter: brightness(0) invert(1);
  }
`;

const styles = {
  textfield: css`
    & .MuiInputLabel-root {
      font-family: 'Montserrat Regular';
      color: ${colors.slate};
      line-height: 1.33;
      letter-spacing: -0.3px;
      margin: 0 0 4px;
      text-align: left;
    }
    & .MuiInput-input {
      font-family: 'Montserrat Regular';
      color: ${colors.prussian};
      font-size: 16px;
      line-height: 1.5;
      letter-spacing: -0.5px;
      text-align: left;
      padding-bottom: 8px !important;
    }
    .MuiFormHelperText-root {
      font-family: 'Montserrat Regular';
      font-size: 12px;
      color: ${colors.slate};
      line-height: 1.33;
      letter-spacing: -0.3px;
    }
    .MuiFormHelperText-root.Mui-error {
      color: ${colors.dragon} !important;
    }
  `,
};
export default styles;
